/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./heading.partial.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { UNSAFE_inverseColorMap } from '@atlaskit/primitives';
import { UNSAFE_useSurface } from '@atlaskit/primitives/compiled';
import { useHeading } from './heading-context';
var sizeTagMap = {
  xxlarge: 'h1',
  xlarge: 'h1',
  large: 'h2',
  medium: 'h3',
  small: 'h4',
  xsmall: 'h5',
  xxsmall: 'h6'
};
var styles = {
  reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var headingColorStylesMap = {
  'color.text': "_syaz1fxt",
  'color.text.inverse': "_syaz15cr",
  'color.text.warning.inverse': "_syazal3n"
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */
var headingSizeStylesMap = {
  xxlarge: "_11c84xcc",
  xlarge: "_11c81c04",
  large: "_11c8nf1z",
  medium: "_11c8lodh",
  small: "_11c8nbxd",
  xsmall: "_11c8140y",
  xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */

var useColor = function useColor(colorProp) {
  var surface = UNSAFE_useSurface();
  if (colorProp) {
    return colorProp;
  }
  if (UNSAFE_inverseColorMap.hasOwnProperty(surface)) {
    return UNSAFE_inverseColorMap[surface];
  }
  return 'color.text';
};

/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */
var Heading = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    size = props.size,
    id = props.id,
    testId = props.testId,
    as = props.as,
    colorProp = props.color;
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production' && as && typeof as !== 'string') {
    throw new Error('`as` prop should be a string.');
  }
  var _useHeading = useHeading(sizeTagMap[size]),
    _useHeading2 = _slicedToArray(_useHeading, 2),
    hLevel = _useHeading2[0],
    inferredElement = _useHeading2[1];
  var Component = as || inferredElement;
  var needsAriaRole = Component === 'div' && hLevel;
  var color = useColor(colorProp);
  return /*#__PURE__*/React.createElement(Component, {
    id: id,
    ref: ref,
    "data-testid": testId,
    role: needsAriaRole ? 'heading' : undefined,
    "aria-level": needsAriaRole ? hLevel : undefined,
    className: ax([styles.reset, size && headingSizeStylesMap[size], headingColorStylesMap[color]])
  }, children);
});
export default Heading;